export const navItems = [
  { path: '/', label: { en: 'Home', es: 'Inicio' } },
  { path: '/services', label: { en: 'Services', es: 'Servicios' } },
  { path: '/about', label: { en: 'About', es: 'Acerca de' } },
  { path: '/testimonials', label: { en: 'Testimonials', es: 'Testimonios' } },
  { path: '/#how-it-works', label: { en: 'How It Works', es: 'Cómo Funciona' } },
  { path: '/contact', label: { en: 'Contact', es: 'Contacto' } },
]

export const companyLinks = [
  { path: '/about', label: { en: 'About Us', es: 'Acerca de Nosotros' } },
  { path: '/#how-it-works', label: { en: 'How It Works', es: 'Cómo Funciona' } },
  { path: '/testimonials', label: { en: 'Testimonials', es: 'Testimonios' } },
  { path: '/#who-we-care-for', label: { en: 'Who We Serve', es: 'A Quién Servimos' } },
  { path: '/faq', label: { en: 'FAQ', es: 'Preguntas Frecuentes' } },
  { path: '/contact', label: { en: 'Contact', es: 'Contacto' } },
]
